<div
  class="modal-header"
  hsDraggable="modal-dialog"
  hsResizable="modal-content"
>
  <h4 class="modal-title">{{ title }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <div class="d-flex justify-content-end mb-2">
    <button nf-button="secondary" (click)="copyHeaders()">Copy Headers</button>
  </div>
  <ng-container>
    <nf-table-layout
      class="fx-entry-table"
      [autoResizeGrid]="false"
      hideTitle
      [isSectionTitle]="false"
      [gridOptions]="gridOptions"
      [data]="rowData"
      hideSearch
      hideClearAll
    >
    </nf-table-layout>
    <nf-form-control
      label="Notes"
      class="notes-control"
      [customErrorMessages]="getFieldValidatorFormatter('transactionNote')"
      [warnings]="noteWarning"
    >
      <textarea
        id="notesText"
        class="form-control"
        [formControl]="note"
        (focus)="disableGridFocus()"
        rows="3"
      ></textarea>
    </nf-form-control>
    <div
      *ngFor="let genericError of genericErrors"
      [hidden]="genericErrors.length == 0"
    >
      <span class="mdi mdi-close-circle-outline text-danger genericIcon"></span>
      <span class="info">{{ genericError }}</span>
    </div>
    <div
      *ngFor="let genericWarning of genericWarnings"
      [hidden]="genericWarnings.length == 0"
    >
      <span
        class="mdi mdi-alert-circle-outline text-warning genericIcon"
      ></span>
      <span class="info">{{ genericWarning }}</span>
    </div>
  </ng-container>
  <hs-loader
    class="{{
      loadingDialog || formSubmitting || isValidating ? 'active' : ''
    }}"
    [loading]="loadingDialog || formSubmitting || isValidating"
    [label]="loadingText"
    [errorLabel]="errorText"
    [showText]="loadingDialog || formSubmitting || isValidating"
  ></hs-loader
  ><hs-dialog-error-details
    [errorHeader]="errorHeader"
    [errorDetails]="errorDetails"
  ></hs-dialog-error-details>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button
      nf-button="secondary"
      [disabled]="disableValidate"
      (click)="validate()"
    >
      Validate
    </button>
    <button
      [disabled]="disableClear"
      nf-button="secondary"
      (click)="clearAll()"
    >
      Clear
    </button>
    <span *ngIf="loadingCounterParty" class="mdi mdi-loading space-left"
      >Loading CounterParties and CurrencyList..</span
    >
  </div>
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button
      nf-button="primary"
      (click)="validateAndSave(true)"
      [disabled]="
        isCommonValidationError ||
        disableSaveValidRows ||
        loadingDialog ||
        formSubmitting ||
        isValidating ||
        !allDataValidated
      "
    >
      Save Valid Rows
    </button>
    <button
      nf-button="primary"
      (click)="validateAndSave()"
      [disabled]="
        !isDataValid ||
        loadingDialog ||
        formSubmitting ||
        isValidating ||
        !allDataValidated
      "
    >
      Save
    </button>
  </div>
</div>
